import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { format } from 'date-fns';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from 'mdbreact';
import { toast } from 'react-toastify';

import NavBar from '../../../components/NavBar';
import api from '../../../services/api';

const OPCOES_STATUS = [
  { label: 'Todas', value: '' },
  { label: 'Pendente', value: 'PENDENTE' },
  { label: 'Paga', value: 'PAGA' },
];

export default function Multas() {
  const [multas, setMultas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  // filtros
  const [listaVtrs, setListaVtrs] = useState([]);
  const [vtrFiltro, setVtrFiltro] = useState(null);
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [statusFiltro, setStatusFiltro] = useState(OPCOES_STATUS[0]);

  // edicao
  const [editando, setEditando] = useState(null); // a multa aberta na modal
  const [valor, setValor] = useState('');
  const [emissor, setEmissor] = useState('');
  const [numeroAuto, setNumeroAuto] = useState('');
  const [status, setStatus] = useState('PENDENTE');
  const [dataPagamento, setDataPagamento] = useState('');
  const [infrator, setInfrator] = useState(null);
  const [bdtVinculado, setBdtVinculado] = useState(null);
  const [salvando, setSalvando] = useState(false);

  // modal de BDTs (mesmo fluxo do cadastro, p/ multa sem infrator)
  const [modalBdts, setModalBdts] = useState(false);
  const [bdts, setBdts] = useState([]);
  const [bdtSelecionado, setBdtSelecionado] = useState(null);

  const nomeDoUsuario = u =>
    u?.nome_social ||
    [u?.nome, u?.sobrenome].filter(Boolean).join(' ') ||
    '—';

  const dataHoraBR = v => {
    try {
      return format(new Date(v), 'dd/MM/yyyy HH:mm');
    } catch (e) {
      return '';
    }
  };

  const buscar = async () => {
    setCarregando(true);
    try {
      const params = {};
      if (vtrFiltro && vtrFiltro.value) params.veiculo_id = vtrFiltro.value;
      if (dataInicio) params.data_inicio = dataInicio;
      if (dataFim) params.data_fim = dataFim;
      if (statusFiltro && statusFiltro.value) params.status = statusFiltro.value;
      const result = await api.get('/multas', { params });
      setMultas(result.data || []);
    } catch (e) {
      toast.error('Falha ao carregar as multas');
    }
    setCarregando(false);
  };

  useEffect(() => {
    api
      .get('/frota', { params: { ativo: true } })
      .then(r =>
        setListaVtrs([
          { label: 'Todas as viaturas', value: '' },
          ...(r.data || []).map(v => ({
            label: `${v.placa}${v.modelo ? ` — ${v.modelo}` : ''}`,
            value: v.id,
          })),
        ])
      )
      .catch(() => {});
    buscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const abrirEdicao = multa => {
    setEditando(multa);
    setValor(multa.valor == null ? '' : String(multa.valor));
    setEmissor(multa.emissor || '');
    setNumeroAuto(multa.numero_auto || '');
    setStatus(multa.status || 'PENDENTE');
    setDataPagamento(multa.data_pagamento || '');
    setInfrator(
      multa.infrator
        ? {
            id: multa.infrator.id,
            nome: nomeDoUsuario(multa.infrator),
            id_funcional: multa.infrator.id_funcional,
          }
        : null
    );
    setBdtVinculado(multa.fk_bdt_id || null);
  };

  const buscarBdts = async () => {
    try {
      const result = await api.get('/multa-busca-bdts', {
        params: {
          veiculo_id: editando.fk_veiculos_id,
          data_hora: editando.data_hora,
        },
      });
      setBdts(result.data || []);
      setBdtSelecionado(null);
      setModalBdts(true);
    } catch (e) {
      toast.error('Falha ao buscar os BDTs');
    }
  };

  const cobreHorario = bdt => {
    const t = new Date(editando.data_hora).getTime();
    const ini = new Date(bdt.data_apresentacao).getTime();
    const fim = bdt.data_dispensa
      ? new Date(bdt.data_dispensa).getTime()
      : Infinity;
    return t >= ini && t <= fim;
  };

  const carregarCondutor = () => {
    const bdt = bdts.find(b => b.id === bdtSelecionado);
    if (!bdt || !bdt.usuario) {
      toast.error('Selecione um BDT');
      return;
    }
    setInfrator({
      id: bdt.usuario.id,
      nome: nomeDoUsuario(bdt.usuario),
      id_funcional: bdt.usuario.id_funcional,
    });
    setBdtVinculado(bdt.id);
    setModalBdts(false);
  };

  const salvarEdicao = async () => {
    if (status === 'PAGA' && !dataPagamento) {
      toast.error('Informe a data de pagamento');
      return;
    }
    setSalvando(true);
    try {
      const result = await api.put(`/multa/${editando.id}`, {
        valor: valor === '' ? null : Number(valor),
        emissor,
        numero_auto: numeroAuto,
        status,
        data_pagamento: status === 'PAGA' ? dataPagamento : null,
        fk_infrator_id: infrator ? infrator.id : null,
        fk_bdt_id: bdtVinculado,
      });
      if (result.data && result.data.erro) {
        toast.error(result.data.erro);
      } else {
        toast.success('Multa atualizada!');
        setEditando(null);
        buscar();
      }
    } catch (e) {
      toast.error(e?.response?.data?.erro || 'Falha ao atualizar a multa');
    }
    setSalvando(false);
  };

  const excluir = async multa => {
    // eslint-disable-next-line no-alert
    if (!window.confirm(`Remover a multa da placa ${multa.veiculo?.placa}?`)) {
      return;
    }
    try {
      await api.delete(`/multa/${multa.id}`);
      toast.success('Multa removida');
      buscar();
    } catch (e) {
      toast.error('Falha ao remover a multa');
    }
  };

  const valorBR = v =>
    v == null
      ? '—'
      : Number(v).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });

  return (
    <NavBar>
      <MDBContainer fluid className="my-4">
        <h3 className="h3-responsive text-center font-weight-bolder">Multas</h3>
        <MDBRow center className="mb-3">
          <Link to="/multa-cadastrar">
            <MDBBtn color="mdb-color" size="sm">
              <MDBIcon icon="plus" className="mr-2" />
              Cadastrar Multa
            </MDBBtn>
          </Link>
        </MDBRow>

        {/* filtros */}
        <MDBRow className="align-items-end mb-3">
          <MDBCol size="12" md="3">
            <span className="grey-text">Viatura</span>
            <Select
              options={listaVtrs}
              placeholder="Todas as viaturas"
              value={vtrFiltro}
              onChange={e => setVtrFiltro(e)}
            />
          </MDBCol>
          <MDBCol size="12" md="2">
            <span className="grey-text">Data início</span>
            <input
              type="date"
              className="form-control"
              value={dataInicio}
              onChange={e => setDataInicio(e.target.value)}
            />
          </MDBCol>
          <MDBCol size="12" md="2">
            <span className="grey-text">Data fim</span>
            <input
              type="date"
              className="form-control"
              value={dataFim}
              onChange={e => setDataFim(e.target.value)}
            />
          </MDBCol>
          <MDBCol size="12" md="2">
            <span className="grey-text">Status</span>
            <Select
              options={OPCOES_STATUS}
              value={statusFiltro}
              onChange={e => setStatusFiltro(e)}
            />
          </MDBCol>
          <MDBCol size="12" md="2">
            <MDBBtn color="dark" size="sm" onClick={buscar} disabled={carregando}>
              <MDBIcon icon="search" className="mr-2" />
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        {/* tabela */}
        <MDBRow className="p-2 d-none d-md-flex mdb-color lighten-3 font-weight-bolder">
          <MDBCol md="1">Placa</MDBCol>
          <MDBCol md="2">Data/Hora</MDBCol>
          <MDBCol md="1">Valor</MDBCol>
          <MDBCol md="2">Emissor</MDBCol>
          <MDBCol md="2">Nº Auto</MDBCol>
          <MDBCol md="2">Infrator</MDBCol>
          <MDBCol md="1">Status</MDBCol>
          <MDBCol md="1">Ações</MDBCol>
        </MDBRow>
        {multas.length === 0 && !carregando && (
          <p className="text-center text-danger mt-3">Nenhuma multa encontrada</p>
        )}
        {multas.map(multa => (
          <MDBRow
            key={multa.id}
            className="p-2 align-items-center bg-white"
            style={{ borderBottom: '1px solid #eee' }}
          >
            <MDBCol size="12" md="1" className="font-weight-bolder">
              {multa.veiculo?.placa || '—'}
            </MDBCol>
            <MDBCol size="12" md="2">
              {dataHoraBR(multa.data_hora)}
            </MDBCol>
            <MDBCol size="12" md="1">
              {valorBR(multa.valor)}
            </MDBCol>
            <MDBCol size="12" md="2">
              {multa.emissor || '—'}
            </MDBCol>
            <MDBCol size="12" md="2">
              {multa.numero_auto || '—'}
            </MDBCol>
            <MDBCol size="12" md="2">
              {multa.infrator ? (
                nomeDoUsuario(multa.infrator)
              ) : (
                <span className="font-italic text-danger">não identificado</span>
              )}
            </MDBCol>
            <MDBCol size="12" md="1">
              <span
                className={`badge ${
                  multa.status === 'PAGA' ? 'badge-success' : 'badge-warning'
                }`}
              >
                {multa.status}
              </span>
            </MDBCol>
            <MDBCol size="12" md="1">
              <MDBIcon
                icon="edit"
                className="mr-3 cursor-pointer text-primary"
                style={{ cursor: 'pointer' }}
                onClick={() => abrirEdicao(multa)}
              />
              <MDBIcon
                icon="trash"
                className="text-danger"
                style={{ cursor: 'pointer' }}
                onClick={() => excluir(multa)}
              />
            </MDBCol>
          </MDBRow>
        ))}
      </MDBContainer>

      {/* modal de edicao */}
      <MDBModal
        isOpen={editando !== null}
        toggle={() => setEditando(null)}
        size="lg"
      >
        <MDBModalHeader toggle={() => setEditando(null)}>
          Editar Multa — {editando?.veiculo?.placa}{' '}
          {editando && `(${dataHoraBR(editando.data_hora)})`}
        </MDBModalHeader>
        <MDBModalBody>
          <MDBRow>
            <MDBCol size="12" md="4">
              <MDBInput
                label="Valor (R$)"
                type="number"
                value={valor}
                onChange={e => setValor(e.target.value)}
              />
            </MDBCol>
            <MDBCol size="12" md="4">
              <MDBInput
                label="Emissor"
                value={emissor}
                onChange={e => setEmissor(e.target.value)}
              />
            </MDBCol>
            <MDBCol size="12" md="4">
              <MDBInput
                label="Nº do auto"
                value={numeroAuto}
                onChange={e => setNumeroAuto(e.target.value)}
              />
            </MDBCol>
          </MDBRow>
          <MDBRow className="align-items-end">
            <MDBCol size="12" md="4">
              <span className="grey-text">Status</span>
              <select
                className="browser-default custom-select"
                value={status}
                onChange={e => setStatus(e.target.value)}
              >
                <option value="PENDENTE">Pendente</option>
                <option value="PAGA">Paga</option>
              </select>
            </MDBCol>
            {status === 'PAGA' && (
              <MDBCol size="12" md="4">
                <span className="grey-text">Data de pagamento</span>
                <input
                  type="date"
                  className="form-control"
                  value={dataPagamento}
                  onChange={e => setDataPagamento(e.target.value)}
                />
              </MDBCol>
            )}
          </MDBRow>
          <hr />
          <p className="font-weight-bold">Real infrator</p>
          <MDBRow className="align-items-center">
            <MDBCol size="12" md="7">
              {infrator ? (
                <div className="p-2 bg-light rounded">
                  <b>{infrator.nome}</b>
                  {infrator.id_funcional
                    ? ` — Id ${infrator.id_funcional}`
                    : ''}
                </div>
              ) : (
                <span className="font-italic grey-text">não identificado</span>
              )}
            </MDBCol>
            <MDBCol size="12" md="5">
              <MDBBtn color="mdb-color" size="sm" onClick={buscarBdts}>
                <MDBIcon icon="search" className="mr-2" />
                Buscar BDTs
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" size="sm" onClick={() => setEditando(null)}>
            Cancelar
          </MDBBtn>
          <MDBBtn
            color="success"
            size="sm"
            disabled={salvando}
            onClick={salvarEdicao}
          >
            Salvar
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>

      {/* modal de BDTs (mesmo fluxo do cadastro) */}
      <MDBModal isOpen={modalBdts} toggle={() => setModalBdts(false)} size="lg">
        <MDBModalHeader toggle={() => setModalBdts(false)}>
          BDTs da viatura no dia da multa
        </MDBModalHeader>
        <MDBModalBody>
          {bdts.length === 0 ? (
            <p className="text-center font-italic">
              Nenhum BDT encontrado para o veículo neste dia.
            </p>
          ) : (
            bdts.map(bdt => (
              <div
                key={bdt.id}
                onClick={() => setBdtSelecionado(bdt.id)}
                style={{ cursor: 'pointer' }}
                className={`p-2 mb-2 rounded border ${
                  bdtSelecionado === bdt.id ? 'border-primary bg-light' : ''
                }`}
              >
                <MDBRow>
                  <MDBCol size="1">
                    <input
                      type="radio"
                      checked={bdtSelecionado === bdt.id}
                      onChange={() => setBdtSelecionado(bdt.id)}
                    />
                  </MDBCol>
                  <MDBCol>
                    <b>{nomeDoUsuario(bdt.usuario)}</b>
                    {editando && cobreHorario(bdt) && (
                      <span className="badge badge-success ml-2">
                        cobre o horário da multa
                      </span>
                    )}
                    <div style={{ fontSize: '12px' }}>
                      {dataHoraBR(bdt.data_apresentacao)} →{' '}
                      {bdt.data_dispensa
                        ? dataHoraBR(bdt.data_dispensa)
                        : 'em aberto'}
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>
            ))
          )}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn
            color="secondary"
            size="sm"
            onClick={() => setModalBdts(false)}
          >
            Cancelar
          </MDBBtn>
          {bdts.length > 0 && (
            <MDBBtn
              color="primary"
              size="sm"
              disabled={!bdtSelecionado}
              onClick={carregarCondutor}
            >
              Carregar condutor
            </MDBBtn>
          )}
        </MDBModalFooter>
      </MDBModal>
    </NavBar>
  );
}
